export default __webpack_public_path__ + "static/AeonikBold-aeb7cd6956242a7491eba35862d956b8.eot";